<syn-message-box leftIcon="information-outline" color="info" class="info-box">
    L'attribution des droits dépend de la sélection des rôles,
    <a href="" (click)='displayRolesInformation($event)'>
        cliquez ici pour voir le détail des rôles et leurs droits.
    </a>
    <br />
    Tout changement de droit peut prendre jusqu'à une minute avant d'être effectif.
</syn-message-box>
